<template>
  <div class="raster-data-map">
    <Map @map-loaded="onMapLoaded" ref="map">
      <DrawControl />
      <BaseMapControl position="bottom-left" :baseMaps="baseMaps" />
      <HomeControl position="top-right" />
      <FullScreenControl position="top-right" />
      <ZoomControl position="top-right" />
    </Map>
  </div>
</template>

<script>
import {
  BaseMapControl,
  DrawControl,
  FullScreenControl,
  HomeControl,
  Map,
  ZoomControl,
} from '@components/Map'
import { API_BASEMAP } from '@api'
import { BaseMapCreate } from '@models/BaseMap'
import bbox from '@turf/bbox'

export default {
  name: 'RasterDataMap',
  components: {
    Map,
    DrawControl,
    BaseMapControl,
    HomeControl,
    FullScreenControl,
    ZoomControl,
  },
  data: () => ({
    map: null,
    baseMaps: [],
  }),
  created() {
    API_BASEMAP.list().then((res) => {
      this.baseMaps = (res.data || []).map((item) => BaseMapCreate(item))
    })
  },
  methods: {
    onMapLoaded(map) {
      this.map = map
      this.$emit('map-loaded', map)
      this.$nextTick(() => this.resize())
    },
    resize() {
      if (this.map && this.map.resize) {
        this.map.resize()
      }
    },
    fitFeature(feature) {
      if (!this.map || !feature) return
      try {
        const bounds = bbox(feature)
        if (!bounds || bounds.length < 4) return
        this.map.fitBounds(
          [
            [bounds[0], bounds[1]],
            [bounds[2], bounds[3]],
          ],
          { padding: 48, duration: 400, maxZoom: 14 }
        )
      } catch (e) {
        console.warn('Fit feature error', e)
      }
    },
  },
}
</script>

<style scoped>
.raster-data-map {
  height: 100%;
  min-height: 0;
  border: 1px solid #dadbdc;
  border-radius: 4px;
  overflow: hidden;
  position: relative;
}
</style>
